import { __assign } from "tslib";
import defaultTheme, { DEFAULT_THEME_NAME } from './defaultTheme';
import { hexToRGBA, getBoxShadow, generateTextColor, getContrastColor, } from './themeHelpers';
var generateOpacityValue = function (color) {
    return color === '#000000' ? 0.3 : 0.6;
};
var generateButtonCSSStates = function (colors, buttonType) {
    var backgroundColor = colors.backgroundColor, color = colors.color, highlightColor = colors.highlightColor;
    // Add less opacity for white text so it is still legible.
    var opacityValue = generateOpacityValue(color);
    var isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton
                ? hexToRGBA(backgroundColor, 0.65)
                : getContrastColor(0.3, opacityValue, backgroundColor),
            boxShadow: getBoxShadow('transparent'),
            color: color,
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: getBoxShadow('transparent'),
            color: color,
        },
        focus: {
            boxShadow: getBoxShadow(hexToRGBA(highlightColor, 0.5)),
            color: color,
            backgroundColor: backgroundColor,
        },
        hover: {
            backgroundColor: isCreateButton
                ? hexToRGBA(backgroundColor, 0.8)
                : getContrastColor(0.1, opacityValue, backgroundColor),
            boxShadow: getBoxShadow('transparent'),
            color: color,
        },
        selected: {
            color: color,
            backgroundColor: backgroundColor,
            borderColor: highlightColor,
            boxShadow: getBoxShadow('transparent'),
        },
    };
};
var generateCreateButtonColors = function (themeBackground, themeHighlight) { return ({
    backgroundColor: themeHighlight,
    color: generateTextColor(themeHighlight),
    highlightColor: themeHighlight,
}); };
export var generateTheme = function (themeColors) {
    var backgroundColor = themeColors.backgroundColor, highlightColor = themeColors.highlightColor, name = themeColors.name;
    var color = generateTextColor(backgroundColor);
    var colors = __assign(__assign({}, themeColors), { color: color });
    if (name === DEFAULT_THEME_NAME) {
        return defaultTheme;
    }
    return {
        mode: {
            create: generateButtonCSSStates(generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color,
            },
            productHome: {
                color: color,
                backgroundColor: highlightColor,
                borderRight: "1px solid " + hexToRGBA(color, 0.5),
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: hexToRGBA(color, 0.5),
                },
                focus: {
                    borderColor: hexToRGBA(highlightColor, 0.8),
                },
                hover: {
                    backgroundColor: getContrastColor(0.1, generateOpacityValue(color), backgroundColor),
                    color: color,
                },
            },
            skeleton: { backgroundColor: color, opacity: 0.08 },
        },
    };
};
export default generateTheme;
//# sourceMappingURL=themeGenerator.js.map